import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { 
  LOCAL_STORAGE_KEY_FOR_DO_NOT_SHOW_SARCASM_TOGGLING_POP_UP, 
  SOURCE_NAME_TWITTER,
  CANCEL_BUTTON_TEXT,
  CONFIRM_BUTTON_TEXT,
  CANCEL_BUTTON_COLOR,
  CONFIRM_BUTTON_COLOR,
  TWEET_TEXT,
  COMMENT_TEXT,
  SARCASTIC_PILL_CLASS,
  NOT_SARCASTIC_PILL_CLASS,
} from '../../redux/constants';
import { SARCASM_THRESHOLD } from '../../../../common/globalConstants';

const TOGGLE_SARCASM_LABEL = 'Toggle sarcasm label';
const REVERT_SARCASM_LABEL = 'Revert sarcasm label';
const MySweetAlertGenerator = withReactContent(Swal);

export class SarcasmTogglingCard extends Component {
static propTypes = {
    userComment: PropTypes.object.isRequired,
    updateIsSarcasmManuallyToggled: PropTypes.func.isRequired,
    commentId: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      userComment: this.props.userComment,
      updateIsSarcasmManuallyToggled: this.props.updateIsSarcasmManuallyToggled,
      sarcasmTogglingPlaceholder: this.props.userComment.sarcasm.isSarcasmManuallyToggled ? REVERT_SARCASM_LABEL : TOGGLE_SARCASM_LABEL,
      isSarcasmManuallyToggled: this.props.userComment.sarcasm.isSarcasmManuallyToggled,
      commentId: this.props.commentId,
      source: this.props.userComment.source.toLowerCase()
    };
  }


  componentDidMount() {
    const userComment = this.props.userComment; 
    const updateIsSarcasmManuallyToggled = this.props.updateIsSarcasmManuallyToggled;
    const commentId = this.props.commentId;
    this.setState({
      userComment: userComment,
      updateIsSarcasmManuallyToggled: updateIsSarcasmManuallyToggled,
      isSarcasmManuallyToggled: userComment.sarcasm.isSarcasmManuallyToggled,
      commentId: commentId
      });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this._hasNewIsSarcasmManuallyToggledValueFromProps(nextProps)) {
      this.setState({
        userComment: nextProps.userComment,
        commentId: nextProps.commentId,
        isSarcasmManuallyToggled: nextProps.userComment.sarcasm.isSarcasmManuallyToggled,
        sarcasmTogglingPlaceholder: this.props.userComment.sarcasm.isSarcasmManuallyToggled ? TOGGLE_SARCASM_LABEL : REVERT_SARCASM_LABEL,
        source: this.props.userComment.source.toLowerCase()
      });
    }
  }

  _hasNewIsSarcasmManuallyToggledValueFromProps(nextProps) {
    return (nextProps.userComment.sarcasm.isSarcasmManuallyToggled !== this.state.isSarcasmManuallyToggled);
  }

  setSarcasmTogglingActionButton() {
    const { isSarcasmManuallyToggled, source } = this.state;
    const [currentState, toggledState] = this._returnSarcasmStatus();

    if (this._hasCheckedDoNotShowSarcasmTogglingPopUpMessage()) {
      this.setIsSarcasmManuallyToggled();
    } 
    else {
      MySweetAlertGenerator.fire({
        html: `<h5><b>${!isSarcasmManuallyToggled ? TOGGLE_SARCASM_LABEL : REVERT_SARCASM_LABEL}</b></h5><br/>
                <p>You are about to toggle the sarcasm label of this ${source === SOURCE_NAME_TWITTER ? TWEET_TEXT : COMMENT_TEXT} from <span class="bolded">${currentState} to ${toggledState}</span>. 
                Would you like to proceed?</p>`,
        input: 'checkbox',
        inputPlaceholder: 'Do not show this message again',
        showCancelButton: true,
        confirmButtonColor: CONFIRM_BUTTON_COLOR,
        cancelButtonColor: CANCEL_BUTTON_COLOR,
        cancelButtonText: CANCEL_BUTTON_TEXT,
        confirmButtonText: CONFIRM_BUTTON_TEXT,
        showCloseButton: true,
        reverseButtons: true,
      }).then(result => {
        if (result.value === 0) {
          this.setIsSarcasmManuallyToggled();
        }
  
        if (result.value === 1) {
          this._setDoNotShowSarcasmTogglingPopUpMessage();
          this.setIsSarcasmManuallyToggled();
        }
      })
    }
  }

  setIsSarcasmManuallyToggled() {
    const { isSarcasmManuallyToggled, userComment, updateIsSarcasmManuallyToggled, commentId } = this.state;

    if (userComment.sarcasm.isSarcasmManuallyToggled === isSarcasmManuallyToggled) {
        updateIsSarcasmManuallyToggled({ 
          commentId: commentId, 
          isSarcasmManuallyToggled: !isSarcasmManuallyToggled,
          emotionCategoryBeforeToggling: userComment.emotion.category,
          sentimentCategoryBeforeToggling: userComment.sentiment.category
        });
    }
  }

  _setDoNotShowSarcasmTogglingPopUpMessage() {
    localStorage.setItem(LOCAL_STORAGE_KEY_FOR_DO_NOT_SHOW_SARCASM_TOGGLING_POP_UP, "true");
  }

  _hasCheckedDoNotShowSarcasmTogglingPopUpMessage() {
    return localStorage.getItem(LOCAL_STORAGE_KEY_FOR_DO_NOT_SHOW_SARCASM_TOGGLING_POP_UP);
  }

  _returnSarcasmStatus() {
    const { isSarcasmManuallyToggled, userComment } = this.state;
    if (userComment.sarcasm.score >= SARCASM_THRESHOLD) {
      if (!isSarcasmManuallyToggled) {
        return [SARCASTIC_PILL_CLASS, NOT_SARCASTIC_PILL_CLASS];
      } else {
        return [NOT_SARCASTIC_PILL_CLASS, SARCASTIC_PILL_CLASS];
      }
    } else if (userComment.sarcasm.score >= 0) {
      if (!isSarcasmManuallyToggled) {
        return [NOT_SARCASTIC_PILL_CLASS, SARCASTIC_PILL_CLASS];
      } else {
        return [SARCASTIC_PILL_CLASS, NOT_SARCASTIC_PILL_CLASS];
      }
    }
  }
  

  render() {
    const {
        sarcasmTogglingPlaceholder
    } = this.state;

    return ( 
      <div
        className="card-header-relevance"
        onClick={() => this.setSarcasmTogglingActionButton()}
      >
        <div className='relevance-placeholder'>{sarcasmTogglingPlaceholder}</div>
      </div>
    )
  }
}

export default SarcasmTogglingCard;


// WEBPACK FOOTER //
// ./src/features/home/components/comment-toggle/SarcasmTogglingCard.js